import CustomerRoutes from "../../../apiRoutes/CustomerRoutes";
import { api } from "../../ConsumeApiController";

export async function getWorkspaces()
{
    const response = await api.get(CustomerRoutes.Workspaces.GetAll);
    return response;
}

export async function getWorkspaceEvents(merchantUuid)
{
    const response = await api.get(CustomerRoutes.Workspaces.GetEvents(merchantUuid));
    return response;
}